var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPictoAssuranceSoluspots(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 114.5,
    height: 114.5,
    viewBox: "0 0 114.5 114.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_720",
    "data-name": "Groupe 720",
    transform: "translate(-422.419 -1899.031)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_715",
    "data-name": "Groupe 715",
    transform: "translate(422.419 1899.031)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_81",
    "data-name": "Ellipse 81",
    cx: 41.036,
    cy: 41.036,
    r: 41.036,
    transform: "matrix(0.582, -0.813, 0.813, 0.582, 0, 66.754)",
    fill: "#ececec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5193",
    "data-name": "Trac\\xE9 5193",
    d: "M506.679,1958.936l-3.4-.374c.142-1.3.227-2.37.268-3.381a48.562,48.562,0,0,0-46.557-50.486l.14-3.416a51.981,51.981,0,0,1,49.833,54.041C506.921,1956.411,506.829,1957.56,506.679,1958.936Z",
    transform: "translate(-397.879 -1897.436)",
    fill: "#41c850"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5194",
    "data-name": "Trac\\xE9 5194",
    d: "M431.4,1975.566a51.979,51.979,0,0,1,25.145-71.754l1.376,3.129a48.554,48.554,0,0,0-23.493,67.032Z",
    transform: "translate(-420.273 -1895.639)",
    fill: "#41c850"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5195",
    "data-name": "Trac\\xE9 5195",
    d: "M468.6,1972.857c-.693,0-1.385-.012-2.083-.041a51.708,51.708,0,0,1-28.687-10.054l2.028-2.751a48.564,48.564,0,0,0,69.8-13.174l2.888,1.83A52.191,52.191,0,0,1,468.6,1972.857Z",
    transform: "translate(-411.477 -1865.098)",
    fill: "#41c850"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_719",
    "data-name": "Groupe 719",
    transform: "translate(449.768 1926.829)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_716",
    "data-name": "Groupe 716"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5196",
    "data-name": "Trac\\xE9 5196",
    d: "M467.6,1916.194h18.175c.716,5.143,4.967,8.532,10.109,9.25v25.913c0,13.861-24.738,25.789-28.284,25.789s-28.284-11.928-28.284-25.789v-25.913c5.141-.718,9.392-4.107,10.108-9.25Z",
    transform: "translate(-437.771 -1914.646)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5197",
    "data-name": "Trac\\xE9 5197",
    d: "M468.247,1979.338c-2.43,0-9.946-3.415-16.37-7.983-6.142-4.37-13.463-11.274-13.463-19.355v-27.262l1.335-.185c4.76-.663,8.211-3.775,8.79-7.93l.185-1.334h39.044l.186,1.334c.58,4.155,4.03,7.267,8.792,7.93l1.334.185V1952c0,8.081-7.321,14.985-13.463,19.355C478.193,1975.923,470.677,1979.338,468.247,1979.338Zm-26.737-51.962V1952c0,12.76,23.9,24.242,26.737,24.242s26.737-11.481,26.737-24.242v-24.623c-4.991-1.127-8.676-4.5-9.831-8.992h-33.81C450.186,1922.875,446.5,1926.249,441.511,1927.376Z",
    transform: "translate(-438.414 -1915.289)",
    fill: "#000f48"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5198",
    "data-name": "Trac\\xE9 5198",
    d: "M463.611,1961.819a20.344,20.344,0,1,1,7.265-39.352l-1.106,2.891a17.252,17.252,0,1,0,11.09,16.117h3.1A20.367,20.367,0,0,1,463.611,1961.819Z",
    transform: "translate(-434.969 -1911.141)",
    fill: "#000f48"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_718",
    "data-name": "Groupe 718",
    transform: "translate(16.423 12.333)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_717",
    "data-name": "Groupe 717"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5199",
    "data-name": "Trac\\xE9 5199",
    d: "M453.563,1933.762l5.685,5.685,14.213-15.634,4.264,4.264-18.477,19.9-9.949-9.949Z",
    transform: "translate(-447.11 -1921.571)",
    fill: "#41c850"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5200",
    "data-name": "Trac\\xE9 5200",
    d: "M460.2,1951.137l-12.179-12.179,6.453-6.455,5.632,5.632,14.212-15.633,6.467,6.465Zm-7.8-12.179,7.718,7.717,16.368-17.627-2.06-2.06L460.21,1942.62l-5.738-5.738Z",
    transform: "translate(-448.019 -1922.502)",
    fill: "#000f48"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictoAssuranceSoluspots);
export default __webpack_public_path__ + "static/media/PICTO_ASSURANCE_SOLUSPOTS.71c7d741ead29e3dcca97c9c85f50390.svg";
export { ForwardRef as ReactComponent };